import * as React from 'react';
import '../style/styles.css';

const NotFound = () => {
    return (
        <div className="about">
          <h1>לא נמצא מידע</h1>
        </div>
    );
}

export default NotFound;

 
